var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "fc9a9255-e89b-4dc0-8903-d91c3453a9eb"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "d3cf8a2e-a9fb-4640-acc4-d9c2b9ef623c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "37ef471c-69c2-4b3a-87cc-d7e372bf792a"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0,0,0)",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-113, -401)",
    d: "M 113 145 C -28.400000000000006 145 -143 259.6 -143 401 C -143 542.4 -28.400000000000006 657 113 657 C 254.4 657 369 542.4 369 401 C 369 259.6 254.4 145 113 145 z M 41.4 508.1 L -8.5 508.1 L -8.5 348.4 L 41.4 348.4 L 41.4 508.1 z M 15.1 328.4 L 14.7 328.4 C -3.400000000000002 328.4 -15.100000000000001 316.2 -15.100000000000001 300.7 C -15.100000000000001 284.9 -3.0000000000000018 273 15.399999999999999 273 C 33.8 273 45.099999999999994 284.9 45.5 300.7 C 45.6 316.1 33.9 328.4 15.1 328.4 z M 241 508.1 L 184.4 508.1 L 184.4 425.5 C 184.4 403.9 175.6 389.1 156.1 389.1 C 141.2 389.1 132.9 399.1 129.1 408.70000000000005 C 127.69999999999999 412.1 127.89999999999999 416.90000000000003 127.89999999999999 421.80000000000007 L 127.89999999999999 508.1000000000001 L 71.8 508.1000000000001 C 71.8 508.1000000000001 72.5 361.70000000000005 71.8 348.4000000000001 L 127.9 348.4000000000001 L 127.9 373.5000000000001 C 131.20000000000002 362.5000000000001 149.1 346.9000000000001 177.7 346.9000000000001 C 213.2 346.9000000000001 241 369.9000000000001 241 419.30000000000007 L 241 508.1 z",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.b43fa7e71a9eaf4a01790870d299911c.svg";
export { ForwardRef as ReactComponent };